import axios from 'axios'
import { toData } from './util'

export function searchGroups(query): Promise {
  return axios.get(`/api/groups/search?query=${query}`).then(toData)
}

export function getGroup(id): Promise {
  return axios.get(`/api/groups/${id}`).then(toData)
}

export function update(group): Promise {
  return axios.put(`/api/groups/${group.id}`, group).then(toData)
}

export function upsert(group): Promise {
  return axios.post(`/api/groups`, group).then(toData)
}

export function getGroupUsers(id): Promise {
  return axios.get(`/api/groups/${id}/users`).then(toData)
}

export function remove(id): Promise {
  return axios.delete(`/api/groups/${id}`).then(toData)
}

export function removeUserMembership(groupId, userId): Promise {
  return axios.delete(`/api/groups/${groupId}/user/${userId}`).then(toData)
}
